import { useAsyncData } from '#imports'

import type { AlgoliaProduct } from '@backmarket/http-api/src/api-specs-search-reco/search/searchAlgolia'
import { useAlgoliaSearchOptions } from '@backmarket/nuxt-layer-algolia/useAlgoliaSearchOptions'
import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import algoliasearch from 'algoliasearch'

import { algoliaHitToBackbox } from '@backmarket/nuxt-layer-recommendation/helpers.ts'

export function useSellerFlashSalesModal(productId: string) {
  const $httpFetch = useHttpFetch()
  const logger = useLogger()

  const { data, pending, refresh } = useAsyncData(
    getAsyncDataKey('seller-flash-sales-modal', { productId }),
    async () => {
      try {
        const algoliaConfig = await $httpFetch(
          '/bm/search/v3/configuration/product-page-deals',
          {
            query: {
              product_id: productId,
            },
          },
        )

        const algoliaSearchOption = useAlgoliaSearchOptions('search')

        const algoliaClient = algoliasearch('dummy_app_id', 'dummy_key', {
          ...algoliaSearchOption,
        })

        const algoliaIndex = algoliaClient.initIndex(
          algoliaConfig.indexes.active.name,
        )

        const requestOptions = {
          ...algoliaConfig.indexes.active.queryParams,
          filters: algoliaConfig.complexFilter ?? '',
          facets: algoliaConfig.facets?.map(({ name }) => name) ?? null,
          page: 0,
          hitsPerPage: 12,
        }

        const { hits } = await algoliaIndex.search<AlgoliaProduct>(
          '',
          requestOptions,
        )

        return hits.map((hit) => algoliaHitToBackbox(hit))
      } catch (e) {
        logger.error('[S&R] PP seller flash sales modal failed', {
          endpointName: 'algoliaSearch',
          type: 'API_REQUEST_FAIL',
          e,
          owners: ['bot-squad-search-and-recommendation-front'],
        })

        return []
      }
    },
    { immediate: false },
  )

  return {
    data,
    pending,
    refresh,
  }
}
